"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkatoStandardRecipeConditions = exports.WorkatoStandardRecipeOutcomes = exports.AdditionalRecipeIdsTypeEnum = exports.CustomWorkflowRecipeTypeEnum = exports.WorkflowStandardApplicationType = exports.WorkflowStandardRecipeTypeEnum = exports.IntegrationStatusEnum = exports.DestinationAttemptStatusTypeEnum = exports.DestinationAttemptStatusEnum = exports.DestinationAttemptEventTypeEnum = exports.DestinationTypeEnum = exports.DestinationStatusEnum = void 0;
var DestinationStatusEnum;
(function (DestinationStatusEnum) {
    DestinationStatusEnum["ACTIVE"] = "Active";
    DestinationStatusEnum["BROKEN"] = "Broken";
    DestinationStatusEnum["DELETED"] = "Deleted";
    DestinationStatusEnum["INACTIVE"] = "Inactive";
})(DestinationStatusEnum || (exports.DestinationStatusEnum = DestinationStatusEnum = {}));
var DestinationTypeEnum;
(function (DestinationTypeEnum) {
    DestinationTypeEnum["ABBY_FLEXICAPTURE_CLOUD"] = "AbbyFlexicaptureCloud";
    DestinationTypeEnum["EMAIL"] = "Email";
    DestinationTypeEnum["WORKATO"] = "Workato";
})(DestinationTypeEnum || (exports.DestinationTypeEnum = DestinationTypeEnum = {}));
var DestinationAttemptEventTypeEnum;
(function (DestinationAttemptEventTypeEnum) {
    DestinationAttemptEventTypeEnum["DOCUMENT_CREATED"] = "DOCUMENT_CREATED";
    DestinationAttemptEventTypeEnum["DOCUMENT_UPDATED"] = "DOCUMENT_UPDATED";
})(DestinationAttemptEventTypeEnum || (exports.DestinationAttemptEventTypeEnum = DestinationAttemptEventTypeEnum = {}));
var DestinationAttemptStatusEnum;
(function (DestinationAttemptStatusEnum) {
    DestinationAttemptStatusEnum["ABORTED"] = "Aborted";
    DestinationAttemptStatusEnum["CREATED"] = "Created";
    DestinationAttemptStatusEnum["FAILED"] = "Failed";
    DestinationAttemptStatusEnum["ON_HOLD"] = "OnHold";
    DestinationAttemptStatusEnum["PENDING"] = "Pending";
    DestinationAttemptStatusEnum["SUCCEEDED"] = "Succeeded";
})(DestinationAttemptStatusEnum || (exports.DestinationAttemptStatusEnum = DestinationAttemptStatusEnum = {}));
var DestinationAttemptStatusTypeEnum;
(function (DestinationAttemptStatusTypeEnum) {
    DestinationAttemptStatusTypeEnum["BOUNCE_INVALID_EMAIL"] = "BounceInvalidEmail";
    DestinationAttemptStatusTypeEnum["BOUNCE_MAILBOX_FULL"] = "BounceMailboxFull";
    DestinationAttemptStatusTypeEnum["EMAIL_MARKED_AS_SPAM"] = "EmailMarkedAsSpam";
    DestinationAttemptStatusTypeEnum["EMAIL_REJECTED"] = "EmailRejected";
    DestinationAttemptStatusTypeEnum["FILESIZE_MISSING"] = "FilesizeMissing";
    DestinationAttemptStatusTypeEnum["FILE_TOO_BIG"] = "FileTooBig";
    DestinationAttemptStatusTypeEnum["GENERAL_ERROR"] = "GeneralError";
    DestinationAttemptStatusTypeEnum["UNKNOWN_DESTINATION_TYPE"] = "UnknownDestinationType";
})(DestinationAttemptStatusTypeEnum || (exports.DestinationAttemptStatusTypeEnum = DestinationAttemptStatusTypeEnum = {}));
var IntegrationStatusEnum;
(function (IntegrationStatusEnum) {
    IntegrationStatusEnum["ACTIVE"] = "Active";
    IntegrationStatusEnum["INACTIVE"] = "InActive";
})(IntegrationStatusEnum || (exports.IntegrationStatusEnum = IntegrationStatusEnum = {}));
var WorkflowStandardRecipeTypeEnum;
(function (WorkflowStandardRecipeTypeEnum) {
    WorkflowStandardRecipeTypeEnum["CUSTOM_STACKED_DISTRIBUTION"] = "CustomStackedDistribution";
    WorkflowStandardRecipeTypeEnum["STANDARD_DISTRIBUTION"] = "StandardDistribution";
    WorkflowStandardRecipeTypeEnum["STANDARD_INBOUND"] = "StandardInbound";
    WorkflowStandardRecipeTypeEnum["STANDARD_OUTBOUND"] = "StandardOutbound";
    WorkflowStandardRecipeTypeEnum["UNKNOWN"] = "Unknown";
})(WorkflowStandardRecipeTypeEnum || (exports.WorkflowStandardRecipeTypeEnum = WorkflowStandardRecipeTypeEnum = {}));
var WorkflowStandardApplicationType;
(function (WorkflowStandardApplicationType) {
    WorkflowStandardApplicationType["DATEV"] = "datev";
    WorkflowStandardApplicationType["DROPBOX"] = "dropbox";
    WorkflowStandardApplicationType["FOLDER_TO_FOLDER"] = "folder_to_folder";
    WorkflowStandardApplicationType["FORWARD_TO_INTEGRATION"] = "forward_to_integration";
    WorkflowStandardApplicationType["FTP"] = "ftp";
    WorkflowStandardApplicationType["GMAIL"] = "gmail";
    WorkflowStandardApplicationType["GOOGLE_DRIVE"] = "google_drive";
    WorkflowStandardApplicationType["INBOX_TO_FOLDER"] = "inbox_to_folder";
    WorkflowStandardApplicationType["ONEDRIVE"] = "onedrive";
    WorkflowStandardApplicationType["OUTLOOK"] = "outlook";
    WorkflowStandardApplicationType["SFTP"] = "sftp";
    WorkflowStandardApplicationType["UNKNOWN"] = "Unknown";
})(WorkflowStandardApplicationType || (exports.WorkflowStandardApplicationType = WorkflowStandardApplicationType = {}));
var CustomWorkflowRecipeTypeEnum;
(function (CustomWorkflowRecipeTypeEnum) {
    CustomWorkflowRecipeTypeEnum["CUSTOM_DISTRIBUTION"] = "CustomDistribution";
    CustomWorkflowRecipeTypeEnum["CUSTOM_OUTBOUND"] = "CustomOutbound";
    CustomWorkflowRecipeTypeEnum["CUSTOM_STACKED_DISTRIBUTION"] = "CustomStackedDistribution";
    CustomWorkflowRecipeTypeEnum["MISC"] = "Misc";
    CustomWorkflowRecipeTypeEnum["UNKNOWN"] = "Unknown";
})(CustomWorkflowRecipeTypeEnum || (exports.CustomWorkflowRecipeTypeEnum = CustomWorkflowRecipeTypeEnum = {}));
var AdditionalRecipeIdsTypeEnum;
(function (AdditionalRecipeIdsTypeEnum) {
    AdditionalRecipeIdsTypeEnum["MISC"] = "Misc";
    AdditionalRecipeIdsTypeEnum["STANDARD_ACTION"] = "StandardAction";
})(AdditionalRecipeIdsTypeEnum || (exports.AdditionalRecipeIdsTypeEnum = AdditionalRecipeIdsTypeEnum = {}));
var WorkatoStandardRecipeOutcomes;
(function (WorkatoStandardRecipeOutcomes) {
    WorkatoStandardRecipeOutcomes["DESTINATION_INTEGRATION"] = "destination:caya_destination_integration_id";
    WorkatoStandardRecipeOutcomes["MOVE"] = "destination:caya_folder_id";
    WorkatoStandardRecipeOutcomes["DATEV"] = "destination:datev_document_type";
    WorkatoStandardRecipeOutcomes["DROPBOX"] = "destination:dropbox_folder_path";
    WorkatoStandardRecipeOutcomes["FTP"] = "destination:ftp_folder_path";
    WorkatoStandardRecipeOutcomes["GDRIVE"] = "destination:gdrive_folder_id";
    WorkatoStandardRecipeOutcomes["CLONE"] = "destination:make_a_copy";
    WorkatoStandardRecipeOutcomes["ONEDRIVE"] = "destination:onedrive_folder_path";
    WorkatoStandardRecipeOutcomes["SFTP"] = "destination:sftp_folder_path";
})(WorkatoStandardRecipeOutcomes || (exports.WorkatoStandardRecipeOutcomes = WorkatoStandardRecipeOutcomes = {}));
var WorkatoStandardRecipeConditions;
(function (WorkatoStandardRecipeConditions) {
    WorkatoStandardRecipeConditions["OUTPUT_FORMATS"] = "destination:caya_output_formats";
    WorkatoStandardRecipeConditions["FOLDER_ID"] = "source:caya_folder_id";
    WorkatoStandardRecipeConditions["REFINEMENT_WORKFLOW_ID"] = "source:caya_refinement_workflow_id";
    WorkatoStandardRecipeConditions["RECIPIENT_NAME"] = "source:filter_recipient";
    WorkatoStandardRecipeConditions["SENDER"] = "source:filter_sender";
    WorkatoStandardRecipeConditions["SUBJECT"] = "source:filter_subject";
    WorkatoStandardRecipeConditions["TAG"] = "source:filter_tag";
    WorkatoStandardRecipeConditions["TEXT"] = "source:filter_text";
})(WorkatoStandardRecipeConditions || (exports.WorkatoStandardRecipeConditions = WorkatoStandardRecipeConditions = {}));
//# sourceMappingURL=document-integrations.js.map